import React, {useEffect, useState} from "react";
import NewsLists from "../../components/news-list";
import {NewsData, TelecastsData} from "../types";
import {getNewsVisible} from "../../service";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import {CommonLists} from "../../components/list/common-lists";


function News() {

    const [lists,setLists] = useState<Array<NewsData>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination()

    useEffect(() => {
        getNewsVisible({
            pageNum
        }).then(res => {
            const lists = res.data.list
            if((lists as Array<NewsData>).length > 0){
                setLists(list => list.concat(lists))
            }else{
                noMore()
            }
        })
    },[pageNum])

    return <div className="news-page">
        <CommonLists lists={ lists } path={'/home/news/@id/detail'}/>
        <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
    </div>
}

export default News;
